@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="login-screen">
  <mat-card appearance="outlined" class="login-form">
    <mat-card-content class="content">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
          <mat-label>Логін</mat-label>
          <input matInput formControlName="login">
          <button type="button" mat-icon-button matSuffix tabindex="-1" aria-hidden="true">
            <mat-icon matSuffix>account_circle</mat-icon>
          </button>
        </mat-form-field>
        <br>

          <mat-form-field appearance="fill">
            <mat-label>Пароль</mat-label>
            <input matInput [type]="hidePwd ? 'password' : 'text'" formControlName="password">
            <button type="button" mat-icon-button matSuffix (click)="hidePwd = !hidePwd" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePwd">
              <mat-icon>{{hidePwd ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>

          <br>
            <button [disabled]="!loginForm.valid || loading" class="login-button" mat-raised-button color="primary">Увійти</button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
